import type { AddressFragments } from './types';

export const isValidAddress = (address: AddressFragments | null | undefined): boolean =>
    Array.isArray(address) && address.some(Boolean);
